import { useRef } from "react";
import "./DataTable.css";

export function Popover({ open, onClose, title, children }) {
  const containerRef = useRef(null);

  if (!open) return null;

  return (
    <div
      className="popoverOverlay"
      onClick={onClose}
      onKeyDown={(event) => {
        if (event.key === "Escape" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClose();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label="Close popover"
    >
      <div
        className="popoverContainer"
        ref={containerRef}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="popoverHeader">
            <h3 className="popoverTitle">{title}</h3>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
}
